module.exports = __webpack_public_path__ + "static/video7-245dadd9e85fdd93b9eddc2236642c94.mp4";